import React, { useContext } from 'react';
import { Text, TextVariant } from '@naf/text';
import { DowngradeContext } from '@pages/downgrade/context/DowngradeContext';
import * as S from './TextWithEmail.styles';

interface TextWithEmailProps {
  value: {
    text: string;
  };
}

export const TextWithEmail = ({ value: { text } }: TextWithEmailProps) => {
  const { email } = useContext(DowngradeContext);

  return (
    <Text variant={TextVariant.ArticleText}>
      {text}{' '}
      <S.BoldText tag="span" variant={TextVariant.ArticleText}>
        {email}
      </S.BoldText>
    </Text>
  );
};

export const TextWithEmailSerializer =
  () =>
  ({ value }: TextWithEmailProps) => <TextWithEmail value={value} />;

export { BoldText } from './TextWithEmail.styles';
